<!-- Modern Angular Homepage Layout -->

<!-- Banner Section -->
<app-banner></app-banner>

<!-- Objective and Events Section -->
<section class="section-light py-2">
  <div class="container">
    <div class="row align-items-start">
      <div class="col-md-7 mb-4" data-aos="fade-up">
        <h2 class="section-title">Our Objective</h2>
        <app-objective></app-objective>
      </div>
      <div class="col-md-5" data-aos="fade-left">
        <h2 class="section-title">Upcoming Events</h2>
        <app-events></app-events>
      </div>
    </div>
  </div>
</section>

<!-- Open Admission Section -->
<section class="section-highlight py-2">
  <div class="fluid-container" data-aos="zoom-in">
    <h2 class="section-title text-center mb-4">Open for Admissions</h2>
    <app-open-admission></app-open-admission>
  </div>
</section>

<!-- Our Motto Section -->
<section class="section-white py-2">
  <div class="fluid-container" data-aos="fade-up">
    <h2 class="section-title text-center mb-4">Our Motto</h2>
    <app-our-moto></app-our-moto>
  </div>
</section>

<!-- CounterUp Section -->
<section class="section-light py-2 border-top">
  <div class="fluid-container" data-aos="fade-up">
    <app-counterup></app-counterup>
  </div>
</section>

<!-- Social View Section -->
<section class="section-white py-2">
  <div class="fluid-container" data-aos="fade-up">
    <h2 class="section-title text-center mb-4">Stay Connected</h2>
    <app-socialview></app-socialview>
  </div>
</section>